import { http } from '../index';
import { trainingSessionStatisticsModifier } from '../formatters';
import { downloadFileFromResponse } from '../helpers';

export const getTrainingSessionStatistics = params => {
  return http
    .get('/training-session-statistic', {
      params,
    })
    .then(res => trainingSessionStatisticsModifier(res.data))
    .catch(error => error.response.data);
};

export const exportTrainingSessionStatistics = params => {
  return http
    .get('/training-session-statistic/export', {
      params,
      responseType: 'blob',
    })
    .then(downloadFileFromResponse)
    .catch(error => error.response.data);
};
